<template>
  <div class="charge">
    <div class="toolBar">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="startTime" placeholder="开始日期" v-model="startDate"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="endTime" placeholder="结束日期·" v-model="endDate"></DatePicker>
      </p>
      <p>
        <Button type="primary" @click="search">查询</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1"></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
        class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="okRefundBtn"
        @on-cancel="cancelRefundBtn"
        ok-text="是" cancel-text="否">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        :scrollable="true"
        :footer-hide='true'
        >
        <div class="accountBox">
          <div class="basiInfo">
            <p>
              <span>患者：</span>
              <span class="keyName">{{patientName}}</span>
            </p>
            <p>
              <span>性别：</span>
              <span>{{sexName}}</span>
            </p>
            <p>
              <span>年龄：</span>
              <span>{{age}}{{ageUnit}}</span>
            </p>
            <p>
              <span>医生：</span>
              <span>{{doctorName}}</span>
            </p>
            <p>
              <span>就诊日期：</span>
              <span>{{diagnosisTime}}</span>
            </p>
            <p>
              <span>诊断：</span>
              <span>{{diagnosis}}</span>
            </p>
          </div>
          <div class="projectBox" v-if="projectItems">
            <p>检测项目</p>
            <ul>
              <li>
                <span>项目名称</span>
                <span>金额</span>
              </li>
              <li v-for="(pro,index) in projectItems" v-bind:key="index">
                <span>{{pro.projectName}}</span>
                <span>{{pro.price}}</span>
              </li>
            </ul>
          </div>
          <div class="projectBox">
            <p v-if="otherItems">其他收费</p>
            <ul v-if="otherItems">
              <li>
                <span>收费项目</span>
                <span>金额</span>
              </li>
              <li v-for="(other,index) in otherItems" v-bind:key="index">
                <span>{{other.itemsName}}</span>
                <span>{{other.price}}</span>
              </li>
            </ul>
            <div class="payBox">
              <ul>
                <li>
                  <label>退款方式：</label>
                  <p>
                    <RadioGroup v-model="payType">
                      <Radio :label="ptype.value" v-for="(ptype,index) in payTypeList" v-bind:key="index" disabled> 
                        <Icon :custom="ptype.icon"></Icon>
                        <span>{{ptype.label}}</span>
                      </Radio>
                    </RadioGroup>
                  </p>
                </li>
                <li>
                  <label>退款金额：</label>
                  <p>
                    <span>{{payPrice}}</span>
                    <span>元</span>
                  </p>
                </li>
                <li class="actualPrice">
                  <p>
                    <span>实退金额：</span>
                    <span>{{actualAmount}}</span>
                    <span>元</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div slot="footer" v-if="false">
            <Button type="text" size="large" @click="cancel">取消</Button>
            <Button type="primary" size="large" @click="confirm">退费</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import {
  haveRefundDetail,refundList,
  cancelRefund
} from "../../../api/charge";
import { tips,replaceT } from "../../../tools";
export default {
  name: 'HaveRefund',
  data () {
    return {
      tableHeight:632,
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      cancelId:0,
      modeIcon:'',
      iconColor:'',
      modal1:false,
      actualAmount:240,
      chargeId:0,
      modelName:'',
      modal2:false,
      modelTitle:'',
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      clinicTime:'',//就诊时间
      clinicTimeList:[],
      startDate:'',//开始日期
      endDate:'',//结束日期
      chargeCategory:'',//收费门类
      modelContent:'',
      chargeCategorys:[],
      columns1:[
        {
          title: '患者',
          key: 'hospitalPatientName',
          align:'center'
        },
        {
          title: '电话',
          key: 'mobile',
          align:'center'
        },
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '年龄',
            key: 'age',
            align:'center'
        },
        {
            title: '年龄单位',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '医生',
            key: 'doctorName',
            align:'center'
        },
        {
            title: '退费日期',
            key: 'chargeTime',
            align:'center',
            // render:(h,params) =>{
            //   return replaceT(params.row.chargeTime);
            // }
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.chargeTime) 
              },
            })
          }
        },
        {
            title: '总金额(元)',
            key: 'amount',
            align:'center'
        },
        {
            title: '退费金额',
            key: 'refundAmount',
            align:'center'
        },
        {
            title: '退费员',
            key: 'refundCashierName',
            align:'center'
        },
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          minWidth:100,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-order'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'chargeDetail';
                      this.modelTitle = '已退费详情';
                      let id = params.row.id;
                      this.haveRefundDetail(id,params.row);
                    },
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-guanbi1'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#C9C9C9',
                    color:'#595757'
                  },
                  on: {
                    click: () => {
                      this.cancelId = params.row.id;
                      this.modal1 = true;
                      this.modelName = 'cancelRefund';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否取消退费?';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                    }
                  }
                }, '取消'),
            ]);
          }
        }
      ],
      data1:[],
      patientName:'',
      sexName:'',
      age:0,
      ageUnit:'',
      doctorName:'',
      diagnosisTime:'',
      diagnosis:'',
      projectItems:[],
      otherItems:[],
      payPrice:0,
      change:'0.00',//找零
      payType:1,
      payTypeList:[
        {
          label:'现金',
          value:1,
          icon:' iconfont icon-zhanghuyue'
        },
        {
          label:'医保',
          value:2,
          icon:' iconfont icon-yibao'
        },
        {
          label:'微信',
          value:3,
          icon:' iconfont icon-weixinzhifu'
        },
        {
          label:'支付宝',
          value:4,
          icon:' iconfont icon-zhifubao'
        },
        {
          label:'银联',
          value:5,
          icon:' iconfont icon-yinhangqia'
        },
        {
          label:'其他',
          value:6,
          icon:''
        }

      ]
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
    },
    loadList(){
      this.search();
    },
    //搜索
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        endTimes: _this.endDate,
        name: _this.doctor,
        nameAndPhone: _this.name,
        size: _this.pageSize,
        starTimes: _this.startDate
      };
      refundList(
        params
      ).then(res => {
        console.log(res)
        let data = res.records;
        _this.total = res.total;
        _this.data1 = data;
      });
    },
    // 收费详情
    haveRefundDetail(id,params){
      let _this = this;
      haveRefundDetail({
        id:id
      }).then(res =>{
        console.log(res);
        _this.chargeId = res.id;
        _this.actualAmount = res.amount;
        _this.patientName = res.hospitalPatientName;
        _this.sexName = params.sex==1?'男':'女';
        _this.age = params.age;
        _this.ageUnit = params.ageUnit;
        _this.doctorName = res.doctorName;
        _this.diagnosisTime = replaceT(res.diagnosisTime);
        _this.diagnosis = res.diagnosis;
        _this.projectItems = res.hisProjectVos;
        _this.otherItems = res.hisOtherOrihechVos;
        _this.payType = res.payType;
        _this.payPrice = res.refundAmount;
      })
    },
    //取消
    cancelRefund(id){
      let _this = this;
      cancelRefund({
        id:id
      }).then(res => {
        console.log(res);
        tips(this,res,'success');
        _this.loadList();
        // location.reload();
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    confirm(){

    },
    cancel(){

    },
    startTime(e){
      this.startDate = e;
      console.log(e)
    },
    endTime(e){
      this.endDate = e;
      console.log(e)
    },
    //取消退费,是
    okRefundBtn(){
      if(this.cancelId>0){
        this.cancelRefund(this.cancelId);
        this.modal1 = false;
      }
    },
    //取消退费,否
    cancelRefundBtn(){
      this.modal1 = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.charge{

}
.charge .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
}
.charge .toolBar>p{
  padding: 5px 0;
  margin-right: 20px;
}
.charge .toolBar>p>label{
  display: inline-block;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}

/* 详情弹框 */
.accountBox{
  width: 100%;
}
.accountBox /deep/ .ivu-modal{
  height: 600px;
  overflow: hidden;
}
.accountBox /deep/ .ivu-modal-content{
  height: 100%;
  overflow: hidden;
}
.ivu-modal-body{
  font-size: 14px;
  overflow: scroll;
  height: 300px;
}
.basiInfo{
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  padding: 0 10px 8px;
  border-bottom: 1px solid #c9c9c9;
}
.basiInfo>p{
  margin-right: 30px;
  line-height: 32px;
  min-width: 100px;
}
.basiInfo>p>span:nth-child(2){
  padding-right: 30px;
  border-right: 1px solid #c9c9c9;
}
.basiInfo .keyName{
  color: #2778e2;
}
.projectBox{
  width: 100%;
}
.projectBox>p{
  padding: 10px 0;
  color:#030303;
  font-size: 14px;
  margin-left: 10px;
}
.projectBox>ul{
  width: 100%;
  border: 1px solid #c9c9c9;
}
.projectBox>ul>li{
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:last-child{
  border: none;
}
.projectBox>ul>li>span{
  text-align: center;
  width: 50%;
}
.projectBox>ul>li:first-child{
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:first-child>span{
  color: #030303;
}
.payBox{
  width: 100%;
}
.payBox>ul{
  width: 100%;
}
.payBox>ul>li{
  display: flex;
  justify-content: flex-start;
  height: 40px;
  line-height: 40px;
}
.payBox>ul>li>label{
  width: 100px;
  text-align: right;
}
.payBox .actualPrice{
  display: flex;
  justify-content: flex-end;
}
.payBox .actualPrice>p{
  margin-right: 10px;
}
.payBox .actualPrice>p>span{
  font-size: 14px;
}
.payBox .actualPrice>p>span:nth-child(2){
  color: #ff4568;
  font-size: 20px;
}
.icon-zhanghuyue{
  color: #fd605f;
}
.icon-yibao{
  color: #06a0a2;
}
.icon-weixinzhifu{
  color: #00ab45;
}
.icon-zhifubao{
  color: #289bd6;
}
.icon-yinhangqia{
  color: #ff9d2d;
}
</style>



// WEBPACK FOOTER //
// src/views/charge/haverefund/HaveRefund.vue